// Modifiez votre composant AccountActivation pour gérer le nouveau code d'erreur

import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

/* -------- Redux -------- */
import { useDispatch, useSelector } from "react-redux";
import { activateAccountRequest, clearUserErrors, clearUserSuccess, loginError } from "../../store/actions";

/* -------- packages -------- */
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Spinner,
} from "reactstrap";

import leftBackgroundImage from '/img/project_authSideImage.jpg';
import { getErrorMessage } from "../../utils/utils";

export default function AccountActivation() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token } = useParams();
  
  const parameters = useSelector(state => state.Parameters);
  document.title = `${t('activateAccount')} | ${parameters.appName}`;
  
  const usersState = useSelector(state => state.Users);
  const [error, setError] = useState('');

  useEffect(() => {
    if (token) {
      dispatch(activateAccountRequest(token, navigate));
    }
  }, [token]);

  useEffect(() => {
    if (error !== '') {
      dispatch(loginError(""));
      setError('');
    } else if (usersState.activationError) {
      setError(usersState.activationError);
      
      toast.error(getErrorMessage(usersState.activationError));
      dispatch(clearUserErrors());
    } else if (usersState.activationSuccess) {
      toast.success(t('accountActivatedSuccess'));
      setTimeout(() => {
        dispatch(clearUserSuccess());
        navigate('/login');
      }, 5000);
    }
  }, [usersState.activationLoading, usersState.activationError, usersState.activationSuccess]);

  // Fonction pour obtenir le message d'erreur approprié
  const getActivationErrorMessage = () => {
    const errorCode = usersState.activationError?.data?.errors?.[0]?.code;
    
    if (errorCode === 'TOKEN_EXPIRED_USER_DELETED') {
      return (
        <div>
          <p>{t('TOKEN_EXPIRED_USER_DELETED')}</p>
        </div>
      );
    } else if (errorCode === 'TOKEN_EXPIRED') {
      return (
        <div>
          <p>{t('TOKEN_EXPIRED')}</p>
        </div>
      );
    } else {
      return (
        <div>
          <p>{errorCode ? t(errorCode) : getErrorMessage(usersState.activationError)}</p>
        </div>
      );
    }
  };

  return (
    <Container fluid className="p-0 m-0 vh-100 overflow-hidden d-flex flex-column authenticationPage">
      <Row className="h-100 m-0">
        <Col lg={8} className="d-none d-lg-block p-0">
          <div className="auth-full-bg p-0 h-100">
            <div className="d-flex h-100 p-0">
              <img src={leftBackgroundImage} alt="" className="img-fluid" />
              <span className="logoLogin">
                <img src={parameters.logo} alt="logo" width={300} className="logo"/>
              </span>
            </div>
          </div>
        </Col>

        <Col lg={4} className="p-0 authenticationContainer h-100 d-flex flex-column justify-content-between flex-grow-1">
          <Row className="d-flex flex-column justify-content-center align-items-center h-25">
            <Col className={"cardHeader mg-0"}>
              <Col lg={12} className="col p-0">
                <div className="text-primary">
                  <h5 className="text-primary">{t('accountActivation')}</h5>
                  <p>{t('accountActivationText')}</p>
                </div>
              </Col>
            </Col>
          </Row>
          
          <Row className="d-flex flex-column align-items-center p-3 h-75">
            <Card className="overflow-hidden">
              <CardBody className="pt-0 interactionContainer">
                <div className="corpContainer text-center p-4">
                  {usersState.activationLoading ? (
                    <>
                      <Spinner color="primary" />
                      <p className="mt-2">{t('activatingAccount')}</p>
                    </>
                  ) : usersState.activationError ? (
                    <>
                      <div className="text-danger">
                        <i className="mdi mdi-alert-circle-outline display-4"></i>
                        <h4>{t('activationFailed')}</h4>
                        {getActivationErrorMessage()}
                      </div>
                    </>
                  ) : usersState.activationSuccess ? (
                    <>
                      <div className="text-success">
                        <i className="mdi mdi-check-circle-outline display-4"></i>
                        <h4>{t('activationSuccess')}</h4>
                        <p>{t('accountActivatedSuccessText')}</p>
                        <p>{t('redirectingToLogin')}</p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="text-primary">
                        <i className="mdi mdi-information-outline display-4"></i>
                        <h4>{t('activatingAccount')}</h4>
                        <p>{t('pleaseWait')}</p>
                      </div>
                    </>
                  )}
                </div>
              </CardBody>
            </Card>
          </Row>

          <Row className="h-25">
            <div className="cardFooter">
              {(() => {
                const errorCode = usersState.activationError?.data?.errors?.[0]?.code;
                return usersState.activationError ? (
                  <div className="signUpFooter">
                    <button className="btn btn-secondary btn-block" type="button" onClick={() => navigate('/login')}>
                      {t('backToLogin')}
                    </button>
                    <button className="btn btn-primary btn-block" type="button" onClick={() => navigate('/register')}>
                      {t('register')}
                    </button>
                  </div>
                ) : (
                  <div className="signUpFooter">
                    <button className="btn btn-secondary btn-block" type="button" onClick={() => navigate('/login')}>
                      {t('backToLogin')}
                    </button>
                  </div>
                );
              })()}
            </div>
          </Row>
        </Col>
      </Row>

      <ToastContainer />
    </Container>
  );
}